import React from "react";
import { Outlet } from "react-router-dom";

const PartnerCategoryRoot = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default PartnerCategoryRoot;
